export default "__VITE_ASSET__84e27043__"